import { render, staticRenderFns } from "./ServiceGrid.vue?vue&type=template&id=21ff0e1d&scoped=true"
import script from "./ServiceGrid.vue?vue&type=script&lang=js"
export * from "./ServiceGrid.vue?vue&type=script&lang=js"
import style0 from "./ServiceGrid.vue?vue&type=style&index=0&id=21ff0e1d&prod&lang=scss&scoped=true"
import style1 from "./ServiceGrid.vue?vue&type=style&index=1&id=21ff0e1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ff0e1d",
  null
  
)

export default component.exports